import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../reducers';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectAuthUserNotifications, selectAuthUserOrgCountry } from '../../auth/auth.selectors';
import { NotificationsItemSettings } from '../../../global/interfaces';
import { take } from 'rxjs/operators';

import { SaveNotificationsSettingsAction } from '../profile.actions';
import { Actions, FieldSize } from 'atlas-cdk';
import { ToastService } from '../../../shared/toaster_/toaster_.service';

export interface Option {
  title: string;
  value: string;
}

export const NotificationsTransactionsOptionsAU: Option[] = [
  {
    title: 'Application',
    value: 'application'
  },
  {
    title: 'Redemption',
    value: 'redemption'
  },
  {
    title: 'Management Fee Rebate',
    value: 'management_fee_rebate'
  },
  {
    title: 'Distribution',
    value: 'distribution'
  },
  {
    title: 'Transfer',
    value: 'transfer'
  },
  {
    title: 'Switch',
    value: 'switch'
  },
  {
    title: 'Reversal',
    value: 'reversal'
  }
];

export const NotificationsTransactionsOptionsNZ: Option[] = [
  {
    title: 'Application',
    value: 'application'
  },
  {
    title: 'Redemption',
    value: 'redemption'
  },
  {
    title: 'Management Fee Rebate',
    value: 'management_fee_rebate'
  },
  {
    title: 'Received',
    value: 'received'
  },
  {
    title: 'Distribution',
    value: 'distribution'
  },
  {
    title: 'PIE Refund',
    value: 'pie_refund'
  },
  {
    title: 'PIE Tax',
    value: 'pie_tax'
  },
  {
    title: 'Transfer',
    value: 'transfer'
  },
  {
    title: 'Switch',
    value: 'switch'
  },
  {
    title: 'Reversal',
    value: 'reversal'
  }
];

export const NotificationsStatementsOptionsAU: Option[] = [
  {
    title: 'Transaction',
    value: 'transaction'
  },
  {
    title: 'Application',
    value: 'application'
  },
  {
    title: 'Redemption Advice',
    value: 'redemption_advice'
  },
  {
    title: 'Distribution Advice',
    value: 'distribution_advice'
  },
  {
    title: 'Tax Statement',
    value: 'tax_statement'
  },
  {
    title: 'Periodic Statement',
    value: 'periodic_statement'
  },
  {
    title: 'Switch Confirmation',
    value: 'switch_confirmation'
  },
  {
    title: 'Transfer',
    value: 'transfer'
  },
  {
    title: 'Fee Rebate Advice',
    value: 'fee_rebate_advice'
  },
  {
    title: 'Account Details Confirmation',
    value: 'account_details_confirmation'
  }
];

export const NotificationsStatementsOptionsNZ: Option[] = [
  {
    title: 'Statement',
    value: 'statement'
  }
];

export const NotificationsDocumentsOptions: Option[] = [
  {
    title: 'Strategic Research',
    value: 'research'
  },
  {
    title: 'Client Documents',
    value: 'documents'
  },
  {
    title: 'Product Documents',
    value: 'product-documents'
  }
];

@Component({
  standalone: false,
  selector: 'dsp-notifications',
  templateUrl: 'notifications.component.html',
  styleUrls: ['notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  public transactions: NotificationsItemSettings;
  public statements: NotificationsItemSettings;
  public documents: NotificationsItemSettings;

  public transactionsOptions = [];
  public statementsOptions = [];
  public documentsOptions = [];
  public country = '';
  public sizeSmall = FieldSize.small;

  private readonly subscription: Subscription = new Subscription();

  public constructor(
    private readonly store: Store<AppState>,
    private readonly _toasterService: ToastService
  ) {
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.subscribeSettings());
  }

  public onSave(): void {
    this.store.dispatch(new SaveNotificationsSettingsAction({
      transactions: { ...this.transactions },
      statements: { ...this.statements },
      documents: { ...this.documents }
    }));
  }

  public onCancel(): void {
    this.store.pipe(
      select(selectAuthUserNotifications),
      take(1)
    ).subscribe(settings => {
      // Deep clone to ensure new object references for change detection
      this.transactions = JSON.parse(JSON.stringify(settings.transactions));
      this.statements = JSON.parse(JSON.stringify(settings.statements));
      this.documents = JSON.parse(JSON.stringify(settings.documents));

      this._toasterService.launchAlertError('Changes have been cancelled', Actions.error);
    });
  }

  public onChangeOptions(feature: string, event: any): void {
    this[feature].options = event;
  }

  public onChangeCheckbox(feature: string, target: string, event): void {

    this[feature][target] = event;

  }

  private subscribeSettings(): Subscription {
    return this.store.pipe(
      select(selectAuthUserNotifications)
    ).subscribe(settings => {
      this.transactions = { ...settings.transactions };
      this.statements = { ...settings.statements };
      this.documents = { ...settings.documents };
    });
  }

  private subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectAuthUserOrgCountry)
    ).subscribe(country => {
      this.country = country;
      if (country === 'au') {
        //this.transactionsOptions = NotificationsTransactionsOptionsAU;
        this.transactionsOptions = NotificationsTransactionsOptionsAU.map(transaction => ({
          label: transaction.title,
          value: transaction.value,
        }));
        this.statementsOptions = NotificationsStatementsOptionsAU.map(statement => ({
          label: statement.title,
          value: statement.value,
        }));
      } else if (country === 'nz') {
        this.transactionsOptions = NotificationsTransactionsOptionsNZ.map(transaction => ({
          label: transaction.title,
          value: transaction.value,
        }));
        this.statementsOptions = NotificationsStatementsOptionsNZ.map(statement => ({
          label: statement.title,
          value: statement.value,
        }));
      }
      this.documentsOptions = NotificationsDocumentsOptions.map(document => ({
        label: document.title,
        value: document.value,
      }));
    });

  }
}
